package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import org.zest.insan_360_website.components.widgets.LocalToast
import org.zest.insan_360_website.data.page_states.dashboard.AdminsDashboardState.fetchAdminsInfo
import org.zest.insan_360_website.data.page_states.dashboard.AdminsDashboardState.needUpdate
import org.zest.insan_360_website.components.widgets.RoleGate
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.pages.user.admins_layout.SuperAdminLayout

@Page
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun AdminsPage(ctx: PageContext) {
    val scope = rememberCoroutineScope()
    val toast = LocalToast.current
    RoleGate(UserRole.SUPER_ADMIN, ctx = ctx) {
        LaunchedEffect(needUpdate) {
            if (needUpdate) {
                fetchAdminsInfo(scope, toast)
                needUpdate = false
            }
        }
        SuperAdminLayout()
    }
}